import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// СТРОКА POPUP'А

const PopupRow: React.FC<{ label: string; selected: boolean; onClick: () => void }> = ({
  label,
  selected,
  onClick,
}) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 14px',
      cursor: 'pointer',
      borderRadius: '14px',
      backgroundColor: selected ? 'rgba(0,122,255,0.15)' : 'transparent',
      transition: 'background-color 0.15s',
      '&:active': { backgroundColor: 'rgba(0,122,255,0.1)' },
    }}
  >
    <Typography
      sx={{
        fontSize: 16,
        fontWeight: selected ? 600 : 500,
        color: selected ? '#007AFF' : '#212121',
      }}
    >
      {label}
    </Typography>
    {selected && <CheckIcon sx={{ color: '#007AFF', fontSize: 20 }} />}
  </Box>
);

// POPUP MULTI SELECT
export const PopupMultiSelect: React.FC<{
  open: boolean;
  onClose: () => void;
  items: { id: string; name: string }[];
  selectedIds: Set<string>;
  onToggle: (id: string) => void;
  onSelectAll: () => void;
  allLabel: string;
}> = ({ open, onClose, items, selectedIds, onToggle, onSelectAll, allLabel }) => {
  if (!open) return null;

  const allSelected = selectedIds.size === 0;

  return (
    <>
      <Box onClick={onClose} sx={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1000 }} />
      <Box
        sx={{
          position: 'fixed',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          width: 'calc(100% - 32px)',
          maxWidth: 359,
          maxHeight: '70vh',
          overflowY: 'auto',
          backgroundColor: '#fff',
          borderRadius: '20px',
          zIndex: 1001,
          boxShadow: '0 8px 32px rgba(0,0,0,0.16)',
          py: '6px',
          px: '6px',
        }}
      >
        <PopupRow label={allLabel} selected={allSelected} onClick={onSelectAll} />
        {items.map((item) => (
          <PopupRow
            key={item.id}
            label={item.name}
            selected={selectedIds.has(item.id)}
            onClick={() => onToggle(item.id)}
          />
        ))}
      </Box>
    </>
  );
};

// КНОПКА ОТКРЫТИЯ POPUP'А (TRIGGER)
export const PopupTrigger: React.FC<{ label: string; onClick: () => void }> = ({ label, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: '#fff',
      borderRadius: '16px',
      padding: '14px 16px',
      mb: 2,
      cursor: 'pointer',
      userSelect: 'none',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      '&:active': { opacity: 0.8 },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FilterListRoundedIcon sx={{ color: 'rgba(33,33,33,0.5)', fontSize: 20 }} />
      <Typography sx={{ fontSize: 16, fontWeight: 600 }}>{label}</Typography>
    </Box>
    <KeyboardArrowDownIcon sx={{ color: '#212121' }} />
  </Box>
);
